import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClientLogsTable from './ClientLogsTable/ClientLogsTable';

import ArrowButton from '../../components/_atomic/ArrowButton/ArrowButton';
// import { publicHash } from '../../utils/constants';
import './ClientsLogsScreen.scss';

class ClientsLogsScreen extends Component {
  static propTypes = {
    match: PropTypes.shape({}).isRequired,
    getUserLogs: PropTypes.func.isRequired,
    resetUserLogs: PropTypes.func.isRequired,
    pageUserLogs: PropTypes.number.isRequired,
    hasMoreUserLogs: PropTypes.bool.isRequired,
    userLogs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    userLogsStatus: PropTypes.string.isRequired,
    sidebarStatus: PropTypes.bool,
  };
  static defaultProps = {
    sidebarStatus: true,
  }
  state = {};
  componentWillUnmount() {
    this.props.resetUserLogs();
  }
  navigateToBack = () => {
    window.history.back();
  }
  render() {
    const {
      match: {
        params: { clientId },
      },
      getUserLogs,
      hasMoreUserLogs,
      pageUserLogs,
      userLogs,
      userLogsStatus,
      sidebarStatus,
    } = this.props;
    const clientsLogsScreenClasses = classNames({
      screen: true,
      'clients-logs-screen': true,
    });
    return (
      <div className={clientsLogsScreenClasses}>
        <ArrowButton onClick={this.navigateToBack} padLeft={sidebarStatus ? 125 : 125} />
        <div className="main-label-no-transform">
          <span>Activity log</span>
        </div>
        <ClientLogsTable
          userId={clientId}
          hasMoreUserLogs={hasMoreUserLogs}
          pageUserLogs={pageUserLogs}
          getUserLogs={getUserLogs}
          userLogs={userLogs}
          userLogsStatus={userLogsStatus}
        />
      </div>
    );
  }
}

export default ClientsLogsScreen;



// WEBPACK FOOTER //
// ./src/containers/ClientsLogsScreen/ClientsLogsScreen.js